import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

function CircleFilledIcon({ classes }) {
  const iconClasses = cn(classes);

  return (
    <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
      <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z" />
    </svg>
  );
}

CircleFilledIcon.propTypes = {
  classes: PropTypes.string,
};

CircleFilledIcon.defaultProps = {
  classes: '',
};

export default CircleFilledIcon;
